export const AUTH_PERSONA_ID = 'AUTH_PERSONA_ID';
export const AUTH_ACCESS_TOKEN = 'AUTH_ACCESS_TOKEN';
export const AUTH_REFRESH_TOKEN = 'AUTH_REFRESH_TOKEN';
export const AUTH_EXPIRES_IN = 'AUTH_EXPIRES_INT';
export const AUTH_EMITTED_IN = 'AUTH_EMITTED_IN';
export const AUTH_STATE = 'AUTH_STATE';
export const AUTH_ROLE_ID = 'AUTH_ROLE_ID';
export const AUTH_TYPE = 'AUTH_TYPE';

export enum AuthType {
  OAUTH_IDP = 'idp',
  OAUTH_LDAP = 'ldap',
  OAUTH_FREE = 'free',
}

export interface GetTokensResult {
  success: boolean;
  error: { code: number; description: string };
  personasId: string[];
}

export interface GetRolesResult {
  success: boolean;
  error: { code: number; description: string };
  roles: Role[];
}

export interface GetRolesArcgisResult {
  success: boolean;
  error: { code: number; description: string };
  roles: RoleArcgis[];
}

export interface Tokens {
  access_token: string;
  refresh_token: string;
  expires_in: number;
}

export interface Role {
  rolId: string;
  rolNombre?: string;
  token?: string;
}

export interface RoleArcgis {
  id: string;
  nombre?: string;
  token?: string;
}
